import { render, staticRenderFns } from "./productTC.vue?vue&type=template&id=56acaaaf&scoped=true&"
import script from "./productTC.vue?vue&type=script&lang=js&"
export * from "./productTC.vue?vue&type=script&lang=js&"
import style0 from "./productTC.vue?vue&type=style&index=0&id=56acaaaf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56acaaaf",
  null
  
)

export default component.exports